var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.14545 8.2385C6.51079 8.58717 7.11969 8.58717 7.52562 8.2385L13.0463 2.96973C13.4116 2.58232 13.4116 2.00121 13.0463 1.65254L12.1127 0.761501C11.7067 0.412833 11.0978 0.412833 10.7325 0.761501L6.79494 4.51937L2.89799 0.761501C2.53265 0.412832 1.92375 0.412832 1.51781 0.761501L0.624762 1.65254C0.218829 2.00121 0.218829 2.58232 0.624761 2.96973L6.14545 8.2385Z","fill":"#CAEE10"}));
}

ChevronInline.defaultProps = {"width":"14","height":"9","viewBox":"0 0 14 9","fill":"none"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
